import { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Header.css'

const Header = () => {
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const servicesDropdownRef = useRef<HTMLDivElement>(null)
  const location = useLocation()

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    setIsMobileMenuOpen(false)
  }



  // Handle scrolling after navigation from other pages
  useEffect(() => {
    if (location.pathname === '/' && location.state && (location.state as any).scrollTo) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        scrollToSection((location.state as any).scrollTo)
      }, 100)
    }
  }, [location])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (servicesDropdownRef.current && !servicesDropdownRef.current.contains(event.target as Node)) {
        setIsServicesDropdownOpen(false)
      }
    }

    if (isServicesDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isServicesDropdownOpen])

  return (
    <header className="main-header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
            <img src="/favicon.png" alt="BOLD! CREATIVE STUDIO" className="header-logo-image" />
          </Link>
        </div>

        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle Navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`header-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => { setIsMobileMenuOpen(false); if (location.pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Home</Link>
          <Link to="/about" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>About</Link>

          <div
            ref={servicesDropdownRef}
            className="nav-link-dropdown"
          >
            <span
              className="nav-link"
              onClick={() => setIsServicesDropdownOpen(!isServicesDropdownOpen)}
              style={{ cursor: 'pointer' }}
            >
              Services
            </span>
            {isServicesDropdownOpen && (
              <div className="nav-dropdown-menu">
                <Link to="/services" className="nav-dropdown-item" onClick={() => { setIsServicesDropdownOpen(false); setIsMobileMenuOpen(false); }}>Services</Link>
                <Link to="/our-process" className="nav-dropdown-item" onClick={() => { setIsServicesDropdownOpen(false); setIsMobileMenuOpen(false); }}>Our Process</Link>
              </div>
            )}
          </div>

          <Link to="/portfolio" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>Portfolio</Link>
          <Link to="/contact" className="header-enquire-button" onClick={() => setIsMobileMenuOpen(false)}>ENQUIRE</Link>
        </nav>
      </div>
    </header>
  )
}

export default Header
